import "@/App.css";
import { BrowserRouter } from "react-router-dom";
import AuthContext from "@/context/AuthContext";
import AppRoutes from "@/pages/AppRoutes";

function App() {
  return (
    <AuthContext>
      {({ user, setUser, login, register, logout }) => (
        <BrowserRouter>
          <AppRoutes user={user} setUser={setUser} login={login} register={register} logout={logout} />
        </BrowserRouter>
      )}
    </AuthContext>
  );
}

export default App;
